module.exports = __webpack_public_path__ + "img/warning-shadow.8a00488f.svg";